import { createRouter, createWebHistory } from 'vue-router'
import { setupRouterGuards } from './guards'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/403',
    name: 'Forbidden',
    component: () => import('@/pages/403.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: () => import('@/components/layout/AdminLayout.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/pages/dashboard/Index.vue'),
        meta: { 
          title: '仪表板',
          requiresAuth: true
        }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/pages/users/Index.vue'),
        meta: { title: '用户管理', requiresAuth: true }
      },
      {
        path: 'memberships',
        name: 'Memberships',
        component: () => import('@/pages/membership/Index.vue'),
        meta: { title: '会员管理', requiresAuth: true, permissions: ['membership:list'] }
      },
      {
        path: 'statistics',
        name: 'StatisticsIndex',
        component: () => import('@/pages/statistics/Index.vue'),
        meta: { title: '数据统计', requiresAuth: true, permissions: ['statistics:view'] }
      },
      {
        path: 'statistics/users',
        name: 'StatisticsUsers',
        component: () => import('@/pages/statistics/Users.vue'),
        meta: { title: '用户分析', requiresAuth: true, permissions: ['statistics:view'] }
      },
      {
        path: 'statistics/usage',
        name: 'StatisticsUsage',
        component: () => import('@/pages/statistics/Usage.vue'),
        meta: { title: '使用习惯分析', requiresAuth: true, permissions: ['statistics:view'] }
      },
      {
        path: 'statistics/regions',
        name: 'StatisticsRegions',
        component: () => import('@/pages/statistics/Regions.vue'),
        meta: { title: '地域分析', requiresAuth: true, permissions: ['statistics:view'] }
      },
      {
        path: 'ai',
        name: 'AiAssistant',
        component: () => import('@/pages/ai/Index.vue'),
        meta: { title: 'AI助理', requiresAuth: true, permissions: ['statistics:view'] }
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: () => import('@/pages/notifications/Index.vue'),
        meta: { title: '通知发布', requiresAuth: true, permissions: ['notifications:manage'] }
      },
      {
        path: 'logs',
        name: 'Logs',
        component: () => import('@/pages/logs/Index.vue'),
        meta: { title: '操作日志', requiresAuth: true, permissions: ['logs:view'] }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/pages/settings/Index.vue'),
        meta: { 
          title: '系统设置',
          requiresAuth: true,
          permissions: ['settings:manage']
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/pages/404.vue'),
    meta: { requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export const installGuards = () => setupRouterGuards(router)

export default router 
